import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import hi from './hi.json';
import te from './te.json';

const KEY = 'shripos.language';

function stored() {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, hi: { translation: hi }, te: { translation: te } },
  lng: stored() ?? 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

/** The language chosen on this device (self-order screens go back to it after each customer). */
export function savedLanguage() {
  return stored() ?? 'en';
}

export function setLanguage(lng) {
  i18n.changeLanguage(lng);
  try {
    localStorage.setItem(KEY, lng);
  } catch {
    /* private mode */
  }
}

export default i18n;
